<template>
  <div class="profile">
    <div v-if="$store.state.userInfo.status !== 'ENABLED'" class="info-container">
      <verification-result :status="$store.state.userInfo.status"></verification-result>
    </div>
    <div v-else>
      <div class="item">
        <div class="label">{{ $t('name') }}</div>
        <div class="value">{{ userInfo.fullName }}</div>
      </div>
      <div class="item">
        <div class="label">{{ $t('mobileNumber') }}</div>
        <div class="value">{{ userInfo.mobileNumber }}</div>
      </div>
      <div class="item" v-if="userInfo.email">
        <div class="label">{{ $t('email') }}</div>
        <div class="value">{{ userInfo.email }}</div>
      </div>
      <div class="item">
        <div v-if="userInfo.credentialType === 'KTP'" class="label">
          {{ $t('ktpNumber') }}
        </div>
        <div v-if="userInfo.credentialType === 'PASSPORT'" class="label">
          {{ $t('passportNumber') }}
        </div>
        <div v-if="userInfo.credentialType === 'ID_CARD'" class="label">
          {{ $t('idNumber') }}
        </div>
        <div class="value">{{ userInfo.credentialNumber }}</div>
      </div>
      <div v-if="frontImageUrl" class="item">
        <div v-if="userInfo.credentialType === 'KTP'" class="label">
          {{ $t('ktpPhoto') }}
        </div>
        <div v-if="userInfo.credentialType === 'PASSPORT'" class="label">
          {{ $t('passportPhoto') }}
        </div>
        <div v-if="userInfo.credentialType === 'ID_CARD'" class="label">
          {{ $t('idCardFrontPhoto') }}
        </div>
        <div class="ktp">
          <img :src="frontImageUrl" class="img">
        </div>
      </div>
      <div v-if="userInfo.credentialType === 'ID_CARD' && backImageUrl" class="item">
        <div class="label">{{ $t('idCardBackPhoto') }}</div>
        <div class="ktp">
          <img :src="backImageUrl" class="img">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VerificationResult from '@/components/common/VerificationResult'

export default {
  i18n: {
    messages: {
      en: {
        email: 'Email',
        idCardBackPhoto: 'ID Photo - Back',
        idCardFrontPhoto: 'ID Photo - Front',
        idNumber: 'ID Number',
        ktpNumber: 'KTP Number',
        ktpPhoto: 'KTP Photo',
        mobileNumber: 'Mobile Number',
        name: 'Name',
        passportNumber: 'Passport Number',
        passportPhoto: 'Passport Photo',
      },
      id: {
        email: 'Email',
        idCardBackPhoto: 'ID Photo - Back',
        idCardFrontPhoto: 'ID Photo - Front',
        idNumber: 'Nomor ID',
        ktpNumber: 'Nomor KTP',
        ktpPhoto: 'Foto KTP',
        mobileNumber: 'Nomor Ponsel',
        name: 'Nama',
        passportNumber: 'Nomor Paspor',
        passportPhoto: 'Foto Paspor',
      },
    },
  },
  components: {
    VerificationResult,
  },
  data() {
    return {
      frontImage: null,
      backImage: null,
      frontImageUrl: null,
      backImageUrl: null,
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo
    },
  },
  async mounted() {
    await this.getImage()
  },
  methods: {
    async getImageUrl(image) {
      const params = {
        fileName: image,
      }
      const response = await this.$http.get('/file/url/ktp', { params })
      return response.data.data
    },
    async getImage() {
      try {
        if (this.userInfo.frontImage) {
          this.frontImageUrl = await this.getImageUrl(this.userInfo.frontImage)
        }
        if (this.userInfo.backImage) {
          this.backImageUrl = await this.getImageUrl(this.userInfo.backImage)
        }
      } catch (error) {
        console.error(error)
      }
    },
    goSignup() {
      this.$router.push('/signup-additional')
    },
  },
}
</script>

<style lang="stylus" scoped>
.profile {
  padding: 16px 0;
}

.item {
  margin-bottom: 16px;
  font-size: 14px;
  .label {
    color: #999;
    margin-bottom: 8px;
  }
  .img {
    width: 100%;
    max-width: 600px;
    max-height: 400px;
  }
}
</style>
